import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChatBox from './components/ChatBox';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import { AdminProvider, useAdmin } from './context/AdminContext';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAdmin();
  return isAuthenticated ? <>{children}</> : <AdminLogin />;
};

const MainLayout: React.FC = () => {
  // Widget modunda farklı stil uygula
  const isWidget = new URLSearchParams(window.location.search).get('widget') === '1';
  
  // Widget için güvenlik başlıkları
  React.useEffect(() => {
    if (isWidget) {
      // Widget modunda embed için gerekli ayarlar
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      document.body.style.overflow = 'auto';
      
      // Widget embed modunda özel ayarlar
      document.documentElement.style.height = '100%';
      document.body.style.height = '100%';
    }
  }, [isWidget]);
  
  return (
    <div className={`${isWidget ? 'h-full' : 'min-h-screen'} bg-gradient-to-br from-red-50 via-white to-red-100 flex items-center justify-center ${isWidget ? 'p-0' : 'p-4'}`}>
      <div className={`w-full ${isWidget ? 'max-w-none h-full' : 'max-w-md h-[700px]'}`}>
        <ChatBox />
      </div>
    </div>
  );
};

function App() {
  return (
    <AdminProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            }
          />
        </Routes>
      </Router>
    </AdminProvider>
  );
}

export default App;